module.exports = __webpack_public_path__ + "img/freevip.41c5ceae.png";